import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Container, Row } from "react-bootstrap";

import PracticeAddresses from "../../PracticeAddresses/PracticeAddresses";

import styles from "./PracticeResults.module.css";

const PracticeResult = (props) => {
	const specialtiesText = props.practice.specialties.map(specialty => specialty.name).join(", ");
	const providerCount = props.practice.providers.length;

	return (
		<Card className={styles.practiceResult}>
			<Card.Header>
				<Link to={{pathname: "/practices/" + props.practice.paans_id_slug}}>
					{props.practice.practice_name}
				</Link>
			</Card.Header>
			<Card.Body>
				<Container>
					<Row>
						<Col xs={12}>{specialtiesText}</Col>
					</Row>
					<hr />
					<Row>
						<Col lg={8}>
							<PracticeAddresses addresses={props.practice.addresses} />
						</Col>
						<Col lg={4}>
							{props.practice.paans_id}
							<hr />
							{providerCount} providers
						</Col>
					</Row>
				</Container>
			</Card.Body>
		</Card>
	)
}

export default PracticeResult;